import { render, staticRenderFns } from "./Bus.vue?vue&type=template&id=4aa7e655&scoped=true"
import script from "./Bus.vue?vue&type=script&lang=js"
export * from "./Bus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa7e655",
  null
  
)

export default component.exports